import React from "react";
import { Box, Button, Grid, Paper, TextField, Typography, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useClient } from "frontend/src/domain/client";
import { useUpdateClient } from "frontend/src/domain/client/actions";
export var ClientLegalEntity = function (_a) {
    var clientId = _a.clientId;
    var _b = useClient(clientId), client = _b.data, isFetched = _b.isFetched;
    var updateClient = useUpdateClient(clientId);
    var _c = React.useState(""), contractNumber = _c[0], setContractNumber = _c[1];
    var _d = React.useState(""), contractDate = _d[0], setContractDate = _d[1];
    var _e = React.useState(""), title = _e[0], setTitle = _e[1];
    var _f = React.useState(""), inn = _f[0], setInn = _f[1];
    var _g = React.useState(""), ogrn = _g[0], setOgrn = _g[1];
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!client) {
            return;
        }
        setContractNumber((_a = client.contractNumber) !== null && _a !== void 0 ? _a : "");
        setContractDate((_b = client.contractDate) !== null && _b !== void 0 ? _b : "");
        setTitle((_d = (_c = client.russianLegalEntity) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : "");
        setInn((_f = (_e = client.russianLegalEntity) === null || _e === void 0 ? void 0 : _e.inn) !== null && _f !== void 0 ? _f : "");
        setOgrn((_h = (_g = client.russianLegalEntity) === null || _g === void 0 ? void 0 : _g.ogrn) !== null && _h !== void 0 ? _h : "");
    }, [client]);
    var onSave = function () {
        updateClient.mutate({
            contractNumber: contractNumber,
            contractDate: contractDate || null,
            legalEntity: {
                title: title,
                inn: inn,
                ogrn: ogrn,
            },
        });
    };
    return (React.createElement(Box, { component: Paper, p: 2, height: "100%" },
        React.createElement(Typography, { variant: "h6" }, "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E"),
        !isFetched ? (React.createElement(Box, { mt: 2 },
            React.createElement(Skeleton, null))) : (React.createElement(React.Fragment, null,
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(TextField, { label: "Номер договора", value: contractNumber, onChange: function (event) { return setContractNumber(event.target.value); }, fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(TextField, { label: "Дата договора", type: "date", value: contractDate, onChange: function (event) { return setContractDate(event.target.value); }, InputLabelProps: { shrink: true }, fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "Название юридического лица", value: title, onChange: function (event) { return setTitle(event.target.value); }, fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(TextField, { label: "ИНН", value: inn, onChange: function (event) { return setInn(event.target.value); }, fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(TextField, { label: "ОГРН", value: ogrn, onChange: function (event) { return setOgrn(event.target.value); }, fullWidth: true }))),
            React.createElement(Box, { display: "flex", justifyContent: "flex-end", mt: 2 },
                React.createElement(Button, { color: "primary", variant: "contained", onClick: onSave, disabled: updateClient.isLoading }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))))));
};
